import React from "react";
import {
  Box,
  Typography,
  Link,
  Paper,
} from "@mui/material";

const HelpContent = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          padding: 4, 
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: 2
        }}
      >
        <Typography 
          variant="body1" 
          sx={{ 
            fontSize: 16,
            lineHeight: 1.6,
            color: "#333",
            fontFamily: "Avenir Book, sans-serif",
            marginBottom: 3
          }}
        >
          For support please access our online Quick Guide. Or contact us by email or phone. 
          Support is available Monday - Friday, 8:00a - 5:00p PST.
        </Typography>

        <Box sx={{ marginBottom: 2 }}>
          <Typography 
            variant="body1" 
            sx={{ 
              fontSize: 16,
              color: "#333",
              fontFamily: "Avenir Book, sans-serif",
              marginBottom: 1
            }}
          >
            <Link 
              href="https://docs.google.com/document/d/1DsHnAUA35ESFRx4psqJnxAl3WLDSp3Hm5AfRgxIZJRg/edit?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#00A7CD",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline"
                }
              }}
            >
              Go to the QuickTales Admin Quick Guide
            </Link>
          </Typography>
        </Box>

        <Box sx={{ marginBottom: 2 }}>
          <Typography 
            variant="body1" 
            sx={{ 
              fontSize: 16,
              color: "#333",
              fontFamily: "Avenir Book, sans-serif"
            }}
          >
            <strong>Email:</strong>{" "}
            <Link 
              href="mailto:support@quicktales.com"
              sx={{
                color: "#00A7CD",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline"
                }
              }}
            >
              support@quicktales.com
            </Link>
          </Typography>
        </Box>

        <Box>
          <Typography 
            variant="body1" 
            sx={{ 
              fontSize: 16,
              color: "#333",
              fontFamily: "Avenir Book, sans-serif"
            }}
          >
            <strong>Phone:</strong>{" "}
            <Link 
              href="tel:424-274-1055"
              sx={{
                color: "#00A7CD",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline"
                }
              }}
            >
              424-274-1055
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default HelpContent;
